import { render, staticRenderFns } from "./dialogs.vue?vue&type=template&id=dc94f478"
import script from "./dialogs.vue?vue&type=script&lang=js"
export * from "./dialogs.vue?vue&type=script&lang=js"
import style0 from "./dialogs.vue?vue&type=style&index=0&id=dc94f478&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports